import { render, staticRenderFns } from "./paymentView.vue?vue&type=template&id=c20f0d66&scoped=true"
import script from "./paymentView.vue?vue&type=script&lang=js"
export * from "./paymentView.vue?vue&type=script&lang=js"
import style0 from "./paymentView.vue?vue&type=style&index=0&id=c20f0d66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20f0d66",
  null
  
)

export default component.exports